import { Link } from 'react-router-dom'
import Seo from '../components/Seo.jsx'

const UPDATED = 'July 2026'

export default function Terms() {
  return (
    <main className="page">
      <Seo
        title="Terms & Conditions | CalculateMyPeptides"
        description="Terms and conditions for using CalculateMyPeptides — an educational peptide reconstitution and dosing calculator. Not medical advice."
      />
      <div className="container page-narrow legal">
        <h1 className="section-title">Terms &amp; Conditions</h1>
        <p className="muted small">Last updated: {UPDATED}</p>

        <p>
          Welcome to CalculateMyPeptides. By accessing or using this website (the “Site”) and its tools,
          you agree to these Terms &amp; Conditions. If you do not agree, please do not use the Site.
        </p>

        <h2>1. Educational purpose — not medical advice</h2>
        <p>
          The Site provides calculators and general educational information about peptides, reconstitution,
          dosing, and wellness metrics. This content is for informational and research purposes only. It is
          not medical advice, diagnosis, or treatment, and is not a substitute for consultation with a
          qualified healthcare professional. Never disregard professional medical advice because of something
          you read here. You are solely responsible for how you use any information or calculation provided.
        </p>

        <h2>2. Eligibility</h2>
        <p>
          You must be at least 21 years old and legally able to enter into these Terms to create an account or
          use the Site. By using the Site you represent that you meet these requirements.
        </p>

        <h2>3. No endorsement of substances</h2>
        <p>
          Many compounds referenced on the Site are research chemicals that are not approved for human use in
          many jurisdictions. Nothing on the Site is an offer, recommendation, or encouragement to buy,
          possess, or administer any substance. You are responsible for complying with all laws that apply to
          you.
        </p>

        <h2>4. Accounts</h2>
        <p>
          You are responsible for keeping your login credentials secure and for all activity under your
          account. Provide accurate information and notify us of any unauthorized use. We may suspend or
          terminate accounts that violate these Terms.
        </p>

        <h2>5. Acceptable use</h2>
        <p>
          You agree not to misuse the Site — including attempting to disrupt it, access it without
          authorization, scrape it at scale, or use it for any unlawful purpose.
        </p>

        <h2>6. Calculations and accuracy</h2>
        <p>
          We strive for accurate math, but calculators depend entirely on the values you enter and general
          formulas. We do not guarantee that any result is correct or appropriate for your situation. Always
          double-check important calculations independently.
        </p>

        <h2>7. Sponsored content and third-party links</h2>
        <p>
          The Site may show sponsored offers and links to third-party websites. We do not control and are not
          responsible for third-party content, products, or practices. Interactions with third parties are
          solely between you and them.
        </p>

        <h2>8. Intellectual property</h2>
        <p>
          The Site’s original content, design, and code are owned by us or our licensors and may not be copied
          or redistributed without permission.
        </p>

        <h2>9. Disclaimer of warranties</h2>
        <p>
          The Site is provided “as is” and “as available,” without warranties of any kind, express or implied,
          including fitness for a particular purpose and non-infringement.
        </p>

        <h2>10. Limitation of liability</h2>
        <p>
          To the maximum extent permitted by law, we are not liable for any indirect, incidental, or
          consequential damages, or for any harm arising from your use of — or reliance on — the Site or its
          calculations.
        </p>

        <h2>11. Changes</h2>
        <p>
          We may update these Terms from time to time. Continued use of the Site after changes take effect
          means you accept the updated Terms.
        </p>

        <h2>12. Contact</h2>
        <p>Questions about these Terms? Reach us through the contact options on the Site.</p>

        <p className="muted small" style={{ marginTop: 24 }}>
          See also our <Link to="/privacy">Privacy Policy</Link>.
        </p>
      </div>
    </main>
  )
}
